<div class="error-content-container">
  <dxo-icon class="primary-icon" icon="lock" color="yellow" [fontSize]="44"></dxo-icon>
  <h1 class="bold heading-md">Oops! Access forbidden</h1>
  <h3 class="heading-sm">You don't have access to Benefits Portal.</h3>
  <hr />
  <p class="info">Please reach out to your manager if you need access or believe this is in error.</p>
  <dxo-button href="https://symetra.com/">Return to symetra.com <dxo-icon icon="external-link"></dxo-icon></dxo-button>
</div>
